// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IInvoiceStatusType {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PAID = 'PAID',
    VOID = 'VOID',
    PAYMENT_INITIATED = 'PAYMENT_INITIATED',
    PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
    PAYMENT_REJECTED = 'PAYMENT_REJECTED',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    REOPEN = 'REOPEN',
    ACTION_REQUIRED = 'ACTION_REQUIRED',
    CANCELED = 'CANCELED'
}


export function instanceOfIInvoiceStatusType(value: any): boolean {
    for (const key in IInvoiceStatusType) {
        if (Object.prototype.hasOwnProperty.call(IInvoiceStatusType, key)) {
            if (IInvoiceStatusType[key as keyof typeof IInvoiceStatusType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IInvoiceStatusTypeFromJSON(json: any): IInvoiceStatusType {
    return IInvoiceStatusTypeFromJSONTyped(json, false);
}

export function IInvoiceStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceStatusType {
    return json as IInvoiceStatusType;
}

export function IInvoiceStatusTypeToJSON(value?: IInvoiceStatusType | null): any {
    return value as any;
}

export function IInvoiceStatusTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): IInvoiceStatusType {
    return value as IInvoiceStatusType;
}

